import { render } from "./index.vue?vue&type=template&id=3c39caaa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c39caaa&scoped=true&lang=css"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c39caaa"]])

export default __exports__